/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class EmailValidationBanner extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);

    }

    componentDidMount() {

        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionView',
        //         'ecommerce': {
        //             'promoView': {
        //                 'promotions': [
        //                     {
        //                         'id': 'email_validation_banner_orange',
        //                         'name': 'Email Validation Banner (orange)',
        //                         'creative': 'email_validation_banner_orange.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'email_validation_banner_orange',
        //         'promotion_name': 'Email Validation Banner (orange)',
        //         'creative_name': 'email_validation_banner_orange.1',
        //         'creative_slot': 'top-promo-bar',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'view_promotion', {
                'promotion_id': 'email_validation_banner_orange',
                'promotion_name': 'Email Validation Banner (orange)',
                'creative_name': 'email_validation_banner_orange.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner View',
                event_data: {
                    banner: 'Email Validation Banner'
                }
            });
        }

    }

    onClick(e) {

        let that = this;

        if (mixpanel) {
            mixpanel.track('Email Validation Click');
        }

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'email_validation_banner_orange',
        //                         'name': 'Email Validation Banner (orange)',
        //                         'creative': 'email_validation_banner_orange.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'email_validation_banner_orange',
        //         'promotion_name': 'Email Validation Banner (orange)',
        //         'creative_name': 'email_validation_banner_orange.1',
        //         'creative_slot': 'top-promo-bar',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'email_validation_banner_orange',
                'promotion_name': 'Email Validation Banner (orange)',
                'creative_name': 'email_validation_banner_orange.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'email_validation_banner_orange',
                'promotion_name': 'Email Validation Banner (orange)',
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner Click',
                event_data: {
                    banner: 'Email Validation Banner'
                }
            });
        }

    }

    render() {
        return (
            <div>
                <div className="icon-wrapper">
                    <i className="icon ion-alert-circled"></i>
                </div>
                Keep your posts flowing! Check your email for a validation link. <Link to="/account">Need another Email?</Link>
            </div>
        );
    }

};

EmailValidationBanner.displayName = "EmailValidationBanner";

export default EmailValidationBanner;
